/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popCodexFieldWallet.vue?vue&type=template&id=1231470b&scoped=true"
import script from "./popCodexFieldWallet.vue?vue&type=script&lang=js"
export * from "./popCodexFieldWallet.vue?vue&type=script&lang=js"
import style0 from "./popCodexFieldWallet.vue?vue&type=style&index=0&id=1231470b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1231470b",
  null
  
)

export default component.exports